module.exports = __webpack_public_path__ + "static/babel17-2217280ce2198147d4d25391303f1a96.jpg";